/** Rebuild IP chart tab state from admission.activity entries. */

export function fluidEntriesFromActivity(activity) {
  return (activity || [])
    .filter((a) => a.kind === 'fluid_balance' && a.data)
    .map((a) => ({
      id: a.entryId,
      ...a.data,
      by: a.data.by || a.byName || '',
    }))
    .sort((a, b) => `${a.date || ''}T${a.time || ''}`.localeCompare(`${b.date || ''}T${b.time || ''}`));
}

export function emarOrdersFromActivity(activity) {
  const orders = new Map();
  const sorted = [...(activity || [])].sort((a, b) => (a.at || '').localeCompare(b.at || ''));
  for (const a of sorted) {
    if (a.kind === 'emar_order' && a.data) {
      const id = a.data.id || a.entryId;
      orders.set(id, { ...orders.get(id), ...a.data, id, administrations: a.data.administrations || orders.get(id)?.administrations || [] });
    }
    if (a.kind === 'emar_admin' && a.data?.orderId) {
      const o = orders.get(a.data.orderId) || { id: a.data.orderId, administrations: [] };
      const admins = [...(o.administrations || [])];
      const idx = admins.findIndex((x) => x.slot === a.data.slot && x.date === a.data.date);
      const row = { slot: a.data.slot, date: a.data.date, status: a.data.status, givenBy: a.data.givenBy, givenAt: a.data.givenAt, notes: a.data.notes };
      if (idx >= 0) admins[idx] = { ...admins[idx], ...row };
      else admins.push(row);
      orders.set(a.data.orderId, { ...o, administrations: admins });
    }
    if (a.kind === 'emar_stop' && a.data?.orderId) {
      const o = orders.get(a.data.orderId);
      if (o) orders.set(a.data.orderId, { ...o, active: false });
    }
  }
  return [...orders.values()].filter((o) => o.drug);
}

export function doctorOrdersFromActivity(activity) {
  const byId = new Map();
  const sorted = [...(activity || [])].sort((a, b) => (a.at || '').localeCompare(b.at || ''));
  for (const a of sorted) {
    if (a.kind !== 'doctor_order' || !a.data) continue;
    const id = a.data.id || a.entryId;
    byId.set(id, {
      ...byId.get(id),
      ...a.data,
      id,
      at: a.data.at || a.at,
      by: a.data.by || a.byName,
    });
  }
  return [...byId.values()].sort((x, y) => (y.at || '').localeCompare(x.at || ''));
}

export function handoversFromActivity(activity) {
  return (activity || [])
    .filter((a) => a.kind === 'handover' && a.data)
    .map((a) => ({ id: a.entryId, ...a.data, at: a.at }))
    .sort((a, b) => (b.at || '').localeCompare(a.at || ''));
}
